import { useState } from "react";
import { supabase } from "../lib/supabase";

export const useSignOut = () => {
  const [loading, setLoading] = useState(false);

  const signOut = async () => {
    try {
      setLoading(true);
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    signOut,
    loading,
  };
};
